import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/consentManager/ConsentManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/utmManager/UTM.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/footer/FooterComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModalProvider"] */ "/app/src/components/ModalContext/ModalContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/navbar/SiteNavbarComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/providers/LocalStorageProvider.tsx");
